import moment from "moment";
import tempDefaultData from "../../assets/data/tempDefaultData.json";
import { convertFromRaw, EditorState } from "draft-js";
import CryptoJS from "crypto-js";
import APP_CONSTANTS, { MESSAGES, URL_REGEX } from "./config";
import { groupBy, isArray } from "lodash";
import { ViewTypes } from "../components/ViewSetting";

import powerBiLogoLight from "../../assets/images/power-bi-logo.svg";
import sigviewLogoLight from "../../assets/images/sigview.svg";
import powerBiLogoDark from "../../assets/images/dark_theme/powerBiLogoDark.svg";
import sigviewLogoDark from "../../assets/images/dark_theme/sigviewLogoDark.svg";
import appsLogoLight from "../../assets/images/apps.svg";
import appsLogoDark from "../../assets/images/dark_theme/appsLogoDark.svg";
import { Typography, styled } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { v4 } from "uuid";

export const decryptToken = (encryptedToken, key) => {
  // key = key.slice(0, 32); // Use the first 32 bytes of the key
  const keyBytes = CryptoJS.enc.Utf8.parse(key.slice(0, 32));
  const ciphertext = CryptoJS.enc.Base64.parse(encryptedToken);

  // Decrypt the ciphertext using AES
  const decryptedBytes = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    keyBytes,
    {
      iv: CryptoJS.enc.Hex.parse("0000000000000000"),
      mode: CryptoJS.mode.CFB,
      padding: CryptoJS.pad.NoPadding,
    }
  );
  // Convert the decrypted data to a string
  const decryptedToken = CryptoJS.enc.Utf8.stringify(decryptedBytes);
  return decryptedToken;
};

export const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export function getFilename(url) {
  var filename = url.split("/").pop();
  return filename.substr(0, filename.lastIndexOf("."));
}

export const formatDateToString = (date, format = "DD MMM YY") =>
  moment(date).format(format);

export const specialFeilds = [
  "report",
  "hybrid",
  "customHybrid",
  "sub_header",
  "textBox",
  "externalApp",
  "dummyBox",
];

export const getValidTextEditorData = (text) => ({
  blocks: [
    {
      key: "637gr",
      text: text || "",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: { "text-align": "start" },
    },
  ],
  entityMap: {},
});

export const getDefaultEditorData = (text = tempDefaultData) => {
  const reqData = EditorState.createWithContent(convertFromRaw(text));
  return reqData;
};

// convert data from string to texteditor format.
export const getEditorState = (text) => {
  let editorState = null;
  if (!text.startsWith('{"blocks"')) {
    const reqText = getValidTextEditorData(text);
    editorState = getDefaultEditorData(reqText);
  } else {
    editorState = getDefaultEditorData(JSON.parse(text));
  }
  return editorState;
};

export const formatTRIQDate = (date, format = "MMM-DD-YYYY H:mm:ss") => {
  const momentDate = moment(+date * 1000);
  return momentDate.format(format);
};

export function formatTimestamp(timestamp) {
  const currentTimestamp = new Date();
  const givenTimestamp = new Date(timestamp);

  const isToday =
    givenTimestamp.getDate() === currentTimestamp.getDate() &&
    givenTimestamp.getMonth() === currentTimestamp.getMonth() &&
    givenTimestamp.getFullYear() === currentTimestamp.getFullYear();

  const isYesterday =
    givenTimestamp.getDate() === currentTimestamp.getDate() - 1 &&
    givenTimestamp.getMonth() === currentTimestamp.getMonth() &&
    givenTimestamp.getFullYear() === currentTimestamp.getFullYear();

  const timeDifference = currentTimestamp - givenTimestamp;
  const minutes = Math.floor(timeDifference / (1000 * 60));
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));

  if (isToday) {
    // If the timestamp is from today, show minutes or hours ago
    return minutes === 0
      ? "Now"
      : minutes < 60
      ? `${minutes} min`
      : `${hours} hr`;
  } else if (isYesterday) {
    // If the timestamp is from yesterday, show yesterday
    return " a day ago";
  } else if (givenTimestamp.getFullYear() < currentTimestamp.getFullYear()) {
    // If the timestamp is from the previous year, show the full date
    const options = { year: "numeric", month: "short", day: "numeric" };
    return givenTimestamp.toLocaleDateString(undefined, options);
  } else {
    // Show the current month
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return monthNames[givenTimestamp.getMonth()];
  }
}

export const getFirstDate = (val) => {
  const date = new Date();
  if (val === "Today") {
    return date.setDate(date.getDate());
  } else if (val === "Last 7 Days") {
    return date.setDate(date.getDate() - 7);
  } else if (val === "Last 14 Days") {
    return date.setDate(date.getDate() - 14);
  } else if (val === "This Year") {
    return new Date(date.getFullYear());
  }
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const checkUrlRegex = (type, appUrl) => {
  let expression = URL_REGEX[type];
  var regex = new RegExp(expression);
  if (!appUrl || appUrl.length <= 0) {
    return false;
  }
  if (appUrl.match(regex)) {
    return true;
  } else {
    return false;
  }
};

export const getfirst18Char = (text) => {
  return text.length > 28 ? text.substring(0, 28) + "..." : text;
};

export const getNormalText = (text) => {
  if (text.startsWith('{"blocks"')) {
    let reqText = "";
    JSON.parse(text)?.blocks?.forEach((item) => {
      if (item.text) {
        reqText = reqText + item.text + "\n";
      }
    });
    return reqText;
  }
  return text;
};

export const getCategoryWiseData = (filterData, viewByFilter) => {
  let catData = [];
  switch (viewByFilter) {
    case "date_category":
      catData = Object.entries(
        groupBy(filterData, (item) => item[viewByFilter]["type"])
      )
        .sort((a, b) => a[0] - b[0])
        .map(([name, data]) => ({
          name: data[0][viewByFilter].value,
          data,
        }));
      break;
    case "app_product_name":
      catData = Object.entries(groupBy(filterData, viewByFilter)).map(
        ([name, data]) => {
          return {
            name: name ? name : "No Data Product",
            data,
          };
        }
      );
      break;
    case "app_category":
      catData = Object.entries(groupBy(filterData, viewByFilter)).map(
        ([name, data]) => ({
          name: name ? name : "No Category",
          data,
        })
      );
      break;
    // need to implement more efficient approach
    case "app_product_lines":
      const noProductLines = "No Product Lines";
      catData = [{ name: noProductLines, data: [] }];
      filterData.forEach((item) => {
        if (item.app_product_lines?.length > 0) {
          item.app_product_lines.forEach((productLine) => {
            const index = catData.findIndex(
              (productLineIn) => productLineIn?.name === productLine
            );
            if (index < 0) catData.unshift({ name: productLine, data: [item] });
            else {
              catData[index].data.push(item);
            }
          });
        } else {
          catData[catData.length - 1].data.push(item);
        }
      });

      break;
    case "app_functions":
      const noFunctions = "No Functions";
      catData = [{ name: noFunctions, data: [] }];
      filterData.forEach((item) => {
        if (item.app_functions?.length > 0) {
          item.app_functions.forEach((fnc) => {
            const index = catData.findIndex((fn) => fn?.name === fnc);
            if (index < 0) catData.unshift({ name: fnc, data: [item] });
            else {
              catData[index].data.push(item);
            }
          });
        } else {
          catData[catData.length - 1].data.push(item);
        }
      });

      break;
    case "app_regions":
      const noRegions = "No Regions";
      catData = [{ name: noRegions, data: [] }];
      filterData.forEach((item) => {
        if (item.app_regions?.length > 0) {
          item.app_regions.forEach((region) => {
            const index = catData.findIndex(
              (regionIn) => regionIn?.name === region
            );
            if (index < 0) catData.unshift({ name: region, data: [item] });
            else {
              catData[index].data.push(item);
            }
          });
        } else {
          catData[catData.length - 1].data.push(item);
        }
      });
      break;
    default:
      break;
  }
  catData[catData.length - 1]?.data?.length <= 0 && catData.pop();
  return catData;
};

export const getDetailNameFromFlag = (userAccess, appType, appSubType) => {
  let detailName = "";
  switch (userAccess?.toLowerCase()) {
    case "yes":
      detailName = getDetailName(appType, appSubType);
      break;
    case "no":
      detailName = MESSAGES.GO_TO_DETAILS;
      break;
    case "pending":
      detailName = MESSAGES.REQUEST_RAISED;
      break;
    default:
      detailName = MESSAGES.GO_TO_DETAILS;
      break;
  }
  return detailName;
};

export const getThemeName = (appTheme) => {
  if (appTheme === "auto") {
    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    return isDarkMode;
  } else {
    return appTheme === "dark" ? true : false;
  }
};

export const getThemeType = (appTheme) => {
  if (appTheme === "auto") {
    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    return isDarkMode ? "dark" : "light";
  } else {
    return appTheme === "dark" ? "dark" : "light";
  }
};

export const IconSource = (
  iconName,
  type,
  appSubType,
  isSigviewTable,
  isDarkMode
) => {
  const powerBiLogo = getThemeName(isDarkMode)
    ? powerBiLogoDark
    : powerBiLogoLight;
  const sigviewLogo = getThemeName(isDarkMode)
    ? sigviewLogoDark
    : sigviewLogoLight;
  const appsLogo = getThemeName(isDarkMode) ? appsLogoDark : appsLogoLight;

  if (type === "Dataset" && !isSigviewTable) {
    return appsLogo;
  }
  switch (iconName) {
    case "analytics":
      return powerBiLogo;
    case "storage":
      return sigviewLogo;
    default:
      return appsLogo;
  }
};

export const getDetailName = (type, appSubType) => {
  let name = "";
  switch (type?.toLowerCase()) {
    case "report":
      name = "Go to Report";
      if (appSubType?.toLowerCase() === "group_report") {
        name = "";
      }
      break;
    case "dataset":
      name = "Explore";
      break;
    case "standalone_app":
      name = "Go to Application";
      break;
    default:
      break;
  }
  return name;
};

const today = new Date();
const formattedDate = today.toLocaleDateString("en-IN", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export const todaysDate = `${formattedDate.split("/")[0]}-${
  formattedDate.split("/")[1]
}-${formattedDate.split("/")[2]}`;

export const checkNewData = (a, b) => {
  if (a === b) {
    return true;
  }

  if (
    typeof a !== "object" ||
    typeof b !== "object" ||
    a === null ||
    b === null
  ) {
    return false;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keysA.length; i++) {
    const currentKey = keysA[i];
    if (
      !keysB.includes(currentKey) ||
      !checkNewData(a[currentKey], b[currentKey])
    ) {
      return false;
    }
  }

  return true;
};

export const resourcesEmptyCheck = (resources) => {
  if (
    resources &&
    resources?.length === 1 &&
    [undefined, ""].includes(resources[0]?.resourceType)
  )
    return [];
  else return resources;
};

export const filterDataModified = (
  modifiedByData,
  filterType,
  searchText,
  selectedViewType
) => {
  if (searchText !== "" || selectedViewType === ViewTypes.TABLE_VIEW) {
    if (filterType === APP_CONSTANTS.ALL_APPS) return modifiedByData;
    const finalData = modifiedByData.filter(
      (elem) => elem.app_sub_type?.toLowerCase() === filterType
    );
    return finalData;
  }

  let finalData = [];
  if (filterType === APP_CONSTANTS.ALL_APPS) {
    finalData = modifiedByData;
    return finalData;
  }

  modifiedByData?.forEach((element) => {
    const data = element?.data?.filter(
      (item) => item.app_sub_type?.toLowerCase() === filterType
    );
    if (data?.length > 0) {
      finalData.push({ ...element, data: data, count: data.length });
    }
  });
  return finalData;
};

export const checkvalidDocumentDetails = (data) => {
  return data.every(
    (documentRow) =>
      documentRow?.documentType && isUrlValid(documentRow?.documentLink)
  );
};

export const omitFields = (obj, fieldsToOmit) => {
  const result = { ...obj };
  for (const field of fieldsToOmit) {
    if (field === "app_resources" || field === "resources") {
      if (result[field] && isArray(result[field]))
        result[field] = result[field]?.map((resource) => {
          return omitFields(resource, ["id"]);
        });
    } else {
      delete result[field];
    }
  }
  return result;
};

export const getInitialsFromEmail = (nameString, separator) => {
  const emailName = nameString.split(separator);
  const fullName = emailName[0].split(".");
  const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
  return initials.toUpperCase();
};

export const filterViewOption = [
  APP_CONSTANTS.GROUP_REPORT,
  APP_CONSTANTS.REPORT,
  APP_CONSTANTS.DATASET,
  APP_CONSTANTS.STANDALONE_APP,
];

export const isUrlMatch = (bi_application, val) => {
  if (
    bi_application === "Google DataStudio" &&
    (val.startsWith("https://datastudio.google.com/embed") ||
      val.startsWith("https://lookerstudio.google.com"))
  ) {
    return true;
  } else if (
    bi_application === "Sharepoint" &&
    val.includes("sharepoint.com") &&
    val.includes("action=embedview")
  ) {
    return true;
  } else if (
    bi_application === "POWER BI" &&
    val.startsWith("https://app.powerbi.com/reportEmbed")
  ) {
    return true;
  } else if (
    bi_application === "TABLEAU" &&
    val.startsWith("https://app.powerbi.com/reportEmbed")
  ) {
    return true;
  } else if (
    bi_application === "GOOGLE STUDIO" &&
    val.startsWith("https://app.powerbi.com/reportEmbed")
  ) {
    return true;
  } else if (
    bi_application === "Power Apps" &&
    val.startsWith("https://apps.powerapps.com")
  ) {
    return true;
  } else if (
    bi_application === "Other Applications" &&
    val.startsWith("https://")
  ) {
    return true;
  } else {
    return false;
  }
};
export const isUrlValid = (link) => {
  const urlRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(\/\S*)?$/;

  if (urlRegex.test(link)) {
    return true;
  } else {
    return false;
  }
};

export function getElementContentWidth(element) {
  var styles = window.getComputedStyle(element);

  return (
    element.clientWidth -
    parseFloat(styles.paddingLeft) -
    parseFloat(styles.paddingRight)
  );
}

export const isDisabledForResources = (resources) => {
  if (resources && resources.length > 1) {
    return !resources?.some((item) => {
      return (
        [undefined, ""].includes(item?.resourceType) ||
        [undefined, ""].includes(item?.resourceLink) ||
        [undefined, ""].includes(item?.resourceLabel) ||
        (item?.resourceLink && !isUrlValid(item?.resourceLink)) ||
        (item?.resourceLabel &&
          item?.resourceLabel?.length > item?.resourceLabel?.trim().length + 1)
      );
    });
  } else if (
    resources?.length === 1 &&
    ["", undefined].includes(resources[0]?.resourceType) &&
    ["", undefined].includes(resources[0]?.resourceLink) &&
    ["", undefined].includes(resources[0]?.resourceLabel)
  ) {
    return true;
  } else if (
    resources?.length === 1 &&
    (["", undefined].includes(resources[0]?.resourceType) ||
      ["", undefined].includes(resources[0]?.resourceLink) ||
      ["", undefined].includes(resources[0]?.resourceLabel) ||
      (resources[0]?.resourceLink && !isUrlValid(resources[0]?.resourceLink)) ||
      (resources[0]?.resourceLabel &&
        resources[0]?.resourceLabel?.length >
          resources[0]?.resourceLabel?.trim().length + 1))
  ) {
    return false;
  }
  return true;
};

export const showUsers = (noOfUsers) => {
  let userString = `${noOfUsers} Users`;
  switch (noOfUsers) {
    case 0:
      userString = "No User";
      break;
    case "":
      userString = "-";
      break;
    case undefined:
      userString = "-";
      break;
    case 1:
      userString = "1 User";
      break;
    default:
      userString = `${noOfUsers} Users`;
      break;
  }
  return userString;
};

export function caseInsensitiveComparator(valueA, valueB) {
  const value1 = valueA ? valueA.toLowerCase() : "";
  const value2 = valueB ? valueB.toLowerCase() : "";

  if (value1 === value2) {
    return 0;
  } else if (value1 < value2) {
    return -1;
  } else {
    return 1;
  }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeFirstLetterOnly(text) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export const CellTypography = styled(Typography)(({ theme }) => ({
  lineHeight: theme.size[15],
  fontSize: theme.size[12],
  color: theme.palette.table.heading,
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export function constructSequenceString(data, properties) {
  return properties.map((property) => data[property]?.[0] || "").join("_");
}

export const getDataModelsData = (
  key,
  workspaces,
  dbValue,
  workspaceValue,
  catalogueValue
) => {
  if (key === "database") {
    return workspaces?.source_details?.map((elem) => ({
      id: elem.id,
      name: elem.name,
    }));
  }
  if (key === "workspace") {
    return workspaces?.source_details
      .find((elem) => elem.name === dbValue)
      ?.workspace?.map((elem) => ({ id: elem.id, name: elem.name }));
  }
  if (key === "catalogue") {
    return workspaces?.source_details
      ?.find((elem) => elem.name === dbValue)
      ?.workspace?.find((elem) => elem.name === workspaceValue)
      ?.catalogue?.map((elem) => ({ id: elem.id, name: elem.name }));
  }
  if (key === "schema") {
    return workspaces?.source_details
      ?.find((elem) => elem.name === dbValue)
      ?.workspace?.find((elem) => elem.name === workspaceValue)
      ?.catalogue?.find((elem) => elem.name === catalogueValue)
      ?.schemas?.map((elem) => ({ id: elem.id, name: elem.name }));
  }
};

export const handleHierarchialDataUtil = async (
  key,
  value,
  workspaces,
  reportDetails
) => {
  let updatedObj = {};
  if (key === "activeDatabase") {
    updatedObj = {
      [key]: value,
      activeWorkspace: workspaces?.source_details?.find(
        (elem) => elem.name === value
      ).workspace?.[0]?.name,
      activeCatalogue: workspaces?.source_details?.find(
        (elem) => elem.name === value
      ).workspace?.[0]?.catalogue[0]?.name,
      activeSchema: workspaces?.source_details?.find(
        (elem) => elem.name === value
      ).workspace?.[0]?.catalogue?.[0]?.schemas[0]?.name,
      // activeGoldLayerTable: [],
    };
  }
  if (key === "activeWorkspace") {
    updatedObj = {
      [key]: value,
      // activeGoldLayerTable: [],
      activeDatabase: reportDetails?.activeDatabase,
      activeCatalogue: workspaces?.source_details
        ?.find((elem) => elem.name === reportDetails?.activeDatabase)
        .workspace?.find((elem) => elem.name === value).catalogue[0]?.name,
      activeSchema: workspaces?.source_details
        ?.find((elem) => elem.name === reportDetails?.activeDatabase)
        .workspace?.find((elem) => elem.name === value).catalogue[0].schemas[0]
        .name,
    };
  }
  if (key === "activeCatalogue") {
    updatedObj = {
      [key]: value,
      // activeGoldLayerTable: [],
      activeDatabase: reportDetails?.activeDatabase,
      activeWorkspace: reportDetails?.activeWorkspace,
      activeSchema: workspaces?.source_details
        ?.find((elem) => elem.name === reportDetails?.activeDatabase)
        .workspace?.find((elem) => elem.name === reportDetails?.activeWorkspace)
        .catalogue?.find((elem) => elem.name === value).schemas[0].name,
    };
  }
  if (key === "activeSchema") {
    updatedObj = {
      [key]: value,
      // activeGoldLayerTable: [],
      activeDatabase: reportDetails?.activeDatabase,
      activeWorkspace: reportDetails?.activeWorkspace,
      activeCatalogue: reportDetails?.activeCatalogue,
    };
  }

  return updatedObj;
};

export const getStatusButton = (status) => {
  switch (status) {
    case APP_CONSTANTS.RAPID_STATUS.PENDING_INFORMATION:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#FBE8D5",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <InfoRoundedIcon sx={{ color: "#ED8A2C", marginRight: "7px" }} />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>
            Approval Pending
          </div>
        </div>
      );

    case APP_CONSTANTS.RAPID_STATUS.TECHNICAL_OWNER_RESPONSE_PENDING:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#FBE8D5",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <InfoRoundedIcon sx={{ color: "#ED8A2C", marginRight: "7px" }} />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>
            Tech Owner Response Pending
          </div>
        </div>
      );

    case APP_CONSTANTS.RAPID_STATUS.REJECTED:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#F1000026",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CancelRoundedIcon sx={{ color: "#F10000", marginRight: "7px" }} />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>
            Approval Rejected
          </div>
        </div>
      );

    case APP_CONSTANTS.RAPID_STATUS.PROCESS_INITIATED:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#55B82A33",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CheckCircleRoundedIcon
            sx={{ color: "#55B82A", marginRight: "7px" }}
          />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>
            Process Initiated
          </div>
        </div>
      );

    case APP_CONSTANTS.RAPID_STATUS.INFRA_IN_PROGRESS:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#FBE8D5",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <InfoRoundedIcon sx={{ color: "#ED8A2C", marginRight: "7px" }} />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>
            Infra In Progress
          </div>
        </div>
      );

    case APP_CONSTANTS.RAPID_STATUS.FINISHED:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#55B82A33",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CheckCircleRoundedIcon
            sx={{ color: "#55B82A", marginRight: "7px" }}
          />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>Finished</div>
        </div>
      );

    case APP_CONSTANTS.RAPID_STATUS.ERROR:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#F1000026",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CancelRoundedIcon sx={{ color: "#F10000", marginRight: "7px" }} />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>
            Error while Deployment
          </div>
        </div>
      );

    default:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#55B82A33",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CheckCircleRoundedIcon
            sx={{ color: "#55B82A", marginRight: "7px" }}
          />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>{status}</div>
        </div>
      );
  }
};

const removeRequired = (str) => {
  return str
    .replace(/\b(required|select)\b/gi, "") // Remove specified words
    .replace(/\s+/g, " ") // Replace multiple spaces with a single space
    .trim(); // Trim leading/trailing spaces
};

const getCostData = (costObject, isDevActive, isUatActive, isProdActive) => {
  const cost = [];
  for (const key in costObject) {
    if (costObject[key].cost !== 0) {
      cost.push({
        id: v4(),
        module: costObject[key].module,
        component: costObject[key].component,
        monthlyCost: {
          dev: isDevActive ? parseFloat(costObject[key].cost.toFixed(2)) : "",
          uat: isUatActive ? parseFloat(costObject[key].cost.toFixed(2)) : "",
          prod: isProdActive ? parseFloat(costObject[key].cost.toFixed(2)) : "",
        },
        annualCost: {
          dev: isDevActive
            ? parseFloat((costObject[key].cost * 12).toFixed(2))
            : "",
          uat: isUatActive
            ? parseFloat((costObject[key].cost * 12).toFixed(2))
            : "",
          prod: isProdActive
            ? parseFloat((costObject[key].cost * 12).toFixed(2))
            : "",
        },
      });
    }
  }

  return cost;
};

export const getCostFromJson = (
  infraJson,
  isDevActive,
  isUatActive,
  isProdActive
) => {
  const costObject = {};
  let key = "";
  let total_cost = 0;
  infraJson.map((curr_category) => {
    const module_name = curr_category.category_name || "";
    const module_id = curr_category?.category_id;
    curr_category.components.map((curr_component) => {
      const {
        component_id,
        component_name,
        component_type,
        value,
        properties,
        dependencies,
      } = curr_component;

      switch (component_type) {
        case "radio":
          key = `${module_id}_${component_id}`;
          properties.map((curr_property) => {
            if ((value || "No") === curr_property.property_value) {
              {
                total_cost += curr_property.cost;
                if (costObject.hasOwnProperty(key)) {
                  costObject[key].cost += curr_property.cost;
                } else {
                  costObject[key] = {
                    module: module_name || component_name || "Default module",
                    component:
                      removeRequired(component_name) || "Default Component",
                    cost: curr_property.cost,
                    value: value || "No",
                  };
                }
              }
            }
          });
          break;

        case "radio-chips":
          if ((dependencies || []).length !== 0) {
            key = `${module_id}_${dependencies[0]?.component_id}`;
          } else {
            key = `${module_id}_${component_id}`;
          }
          properties.map((curr_property) => {
            if (
              (value ||
                (component_name === "Milvus Storage Size"
                  ? "5GB"
                  : "Small")) === curr_property.property_value
            ) {
              if (costObject.hasOwnProperty(key)) {
                let parentValue = costObject[key]?.value;
                if (parentValue === "Yes") {
                  costObject[key].cost += curr_property.cost;
                  total_cost += curr_property.cost;
                }
              } else {
                costObject[key] = {
                  module: module_name || component_name || "Default module",
                  component:
                    removeRequired(component_name) || "Default Component",
                  cost: curr_property.cost,
                };
                total_cost += curr_property.cost;
              }
            }
          });
          break;

        case "check-box":
          if ((dependencies || []).length !== 0) {
            key = `${module_id}_${dependencies[0]?.component_id}`;
          } else {
            key = `${module_id}_${component_id}`;
          }
          properties.map((curr_property) => {
            if (String(value || false) === curr_property.property_value) {
              if (costObject.hasOwnProperty(key)) {
                let parentValue = costObject[key]?.value;
                if (parentValue === "Yes") {
                  total_cost += curr_property.cost;
                  costObject[key].cost += curr_property.cost;
                }
              } else {
                total_cost += curr_property.cost;
                costObject[key] = {
                  module: module_name || component_name || "Default module",
                  component:
                    removeRequired(component_name) || "Default Component",
                  cost: curr_property.cost,
                };
              }
            }
          });
          break;

        case "single-select-dropdown":
          if ((dependencies || []).length !== 0) {
            key = `${module_id}_${dependencies[0]?.component_id}`;
          } else {
            key = `${module_id}_${component_id}`;
          }
          properties.map((curr_property) => {
            if ((value || "") === curr_property.property_value) {
              if (costObject.hasOwnProperty(key)) {
                let parentValue = costObject[key]?.value;
                if (parentValue === "Yes") {
                  total_cost += curr_property.cost;
                  costObject[key].cost += curr_property.cost;
                }
              } else {
                total_cost += curr_property.cost;
                costObject[key] = {
                  module: module_name || component_name || "Default module",
                  component:
                    removeRequired(component_name) || "Default Component",
                  cost: curr_property.cost,
                };
              }
            }
          });
          break;

        case "multi-select-dropdown":
          let local_cost = 0;

          if (module_id === 2 && component_id === 35) {
            value.map((item) => {
              costObject[`${item.property_id}_${item.property_value}`] = {
                module: item.property_id,
                component: item.property_value,
                cost: item?.cost || 0,
              };
              total_cost += item?.cost || 0;
            });
          } else {
            properties?.map((curr_property) => {
              if ((value || []).includes(curr_property.property_value)) {
                {
                  if (curr_property?.cost > 0) {
                    local_cost += curr_property.cost;
                  }
                }
              }
            });

            if ((dependencies || []).length !== 0) {
              key = `${module_id}_${dependencies[0]?.component_id}`;
            } else {
              key = `${module_id}_${component_id}`;
            }

            total_cost += local_cost;
            if (costObject.hasOwnProperty(key)) {
              let parentValue = costObject[key]?.value;
              if (parentValue === "Yes") {
                total_cost += local_cost;
                costObject[key].cost += local_cost;
              }
            } else {
              total_cost += local_cost;
              costObject[key] = {
                module: module_name || component_name || "Default module",
                component:
                  removeRequired(component_name) || "Default Component",
                cost: local_cost,
              };
            }
          }

          break;

        case "list":
          (value || [])?.map((curr_value) => {
            let total_env_up = 0;
            if (isDevActive) {
              total_env_up += 1;
            }
            if (isUatActive) {
              total_env_up += 1;
            }
            if (isProdActive) {
              total_env_up += 1;
            }
            const result = parseFloat(curr_value?.cost || 0) / total_env_up;
            const costFloat = parseFloat(result.toFixed(2));

            key = `${module_id}_${curr_value.id}`;
            total_cost += costFloat;
            costObject[key] = {
              module: module_name || component_name || "Default module",
              component: curr_value?.name || "",
              cost: costFloat,
            };
          });
          break;

        default:
          break;
      }
    });
  });

  costObject["total"] = {
    module: "Total",
    component: "",
    cost: total_cost,
  };

  return getCostData(costObject, isDevActive, isUatActive, isProdActive);
};

export const getTotalCost = (
  infraJson,
  isDevActive,
  isUatActive,
  isProdActive
) => {
  const costObject = {};
  let key = "";
  let total_cost = 0;
  infraJson.map((curr_category) => {
    const module_name = curr_category.category_name || "";
    const module_id = curr_category?.category_id;
    curr_category.components.map((curr_component) => {
      const {
        component_id,
        component_name,
        component_type,
        value,
        properties,
        dependencies,
      } = curr_component;

      switch (component_type) {
        case "radio":
          key = `${module_id}_${component_id}`;
          properties.map((curr_property) => {
            if ((value || "No") === curr_property.property_value) {
              {
                total_cost += curr_property.cost;
                if (costObject.hasOwnProperty(key)) {
                  costObject[key].cost += curr_property.cost;
                } else {
                  costObject[key] = {
                    module: module_name || component_name || "Default module",
                    component:
                      removeRequired(component_name) || "Default Component",
                    cost: curr_property.cost,
                    value: value || "No",
                  };
                }
              }
            }
          });
          break;

        case "radio-chips":
          if ((dependencies || []).length !== 0) {
            key = `${module_id}_${dependencies[0]?.component_id}`;
          } else {
            key = `${module_id}_${component_id}`;
          }
          properties.map((curr_property) => {
            if (
              (value ||
                (component_name === "Milvus Storage Size"
                  ? "32GB"
                  : "Small")) === curr_property.property_value
            ) {
              if (costObject.hasOwnProperty(key)) {
                let parentValue = costObject[key]?.value;
                if (parentValue === "Yes") {
                  costObject[key].cost += curr_property.cost;
                  total_cost += curr_property.cost;
                }
              } else {
                costObject[key] = {
                  module: module_name || component_name || "Default module",
                  component:
                    removeRequired(component_name) || "Default Component",
                  cost: curr_property.cost,
                };
                total_cost += curr_property.cost;
              }
            }
          });
          break;

        case "check-box":
          if ((dependencies || []).length !== 0) {
            key = `${module_id}_${dependencies[0]?.component_id}`;
          } else {
            key = `${module_id}_${component_id}`;
          }
          properties.map((curr_property) => {
            if (String(value || false) === curr_property.property_value) {
              if (costObject.hasOwnProperty(key)) {
                let parentValue = costObject[key]?.value;
                if (parentValue === "Yes") {
                  total_cost += curr_property.cost;
                  costObject[key].cost += curr_property.cost;
                }
              } else {
                total_cost += curr_property.cost;
                costObject[key] = {
                  module: module_name || component_name || "Default module",
                  component:
                    removeRequired(component_name) || "Default Component",
                  cost: curr_property.cost,
                };
              }
            }
          });
          break;

        case "single-select-dropdown":
          if ((dependencies || []).length !== 0) {
            key = `${module_id}_${dependencies[0]?.component_id}`;
          } else {
            key = `${module_id}_${component_id}`;
          }
          properties.map((curr_property) => {
            if ((value || "") === curr_property.property_value) {
              if (costObject.hasOwnProperty(key)) {
                let parentValue = costObject[key]?.value;
                if (parentValue === "Yes") {
                  total_cost += curr_property.cost;
                  costObject[key].cost += curr_property.cost;
                }
              } else {
                total_cost += curr_property.cost;
                costObject[key] = {
                  module: module_name || component_name || "Default module",
                  component:
                    removeRequired(component_name) || "Default Component",
                  cost: curr_property.cost,
                };
              }
            }
          });
          break;

        case "multi-select-dropdown":
          let local_cost = 0;
          if (module_id === 2 && component_id === 35) {
            value.map((item) => {
              local_cost += item?.cost || 0;
            });
            total_cost += local_cost;
          } else {
            properties?.map((curr_property) => {
              if ((value || []).includes(curr_property.property_value)) {
                {
                  if (curr_property?.cost > 0) {
                    local_cost += curr_property.cost;
                  }
                }
              }
            });

            if ((dependencies || []).length !== 0) {
              key = `${module_id}_${dependencies[0]?.component_id}`;
            } else {
              key = `${module_id}_${component_id}`;
            }

            total_cost += local_cost;
            if (costObject.hasOwnProperty(key)) {
              let parentValue = costObject[key]?.value;
              if (parentValue === "Yes") {
                total_cost += local_cost;
                costObject[key].cost += local_cost;
              }
            } else {
              total_cost += local_cost;
              costObject[key] = {
                module: module_name || component_name || "Default module",
                component:
                  removeRequired(component_name) || "Default Component",
                cost: local_cost,
              };
            }
          }

          break;

        case "list":
          (value || [])?.map((curr_value) => {
            let total_env_up = 0;
            if (isDevActive) {
              total_env_up += 1;
            }
            if (isUatActive) {
              total_env_up += 1;
            }
            if (isProdActive) {
              total_env_up += 1;
            }
            const result = parseFloat(curr_value?.cost || 0) / total_env_up;
            const costFloat = parseFloat(result.toFixed(2));

            key = `${module_id}_${curr_value.id}`;
            total_cost += costFloat;
            costObject[key] = {
              module: module_name || component_name || "Default module",
              component: curr_value?.name || "",
              cost: costFloat,
            };
          });
          break;

        default:
          break;
      }
    });
  });
  let activeEnvironments = 0;

  if (isDevActive) activeEnvironments++;
  if (isUatActive) activeEnvironments++;
  if (isProdActive) activeEnvironments++;

  const final_cost = activeEnvironments * total_cost;
  return final_cost;
};

export const getDevEnvironment = (infraJson) => {
  const component = infraJson[0]?.components[1];
  return {
    dev: component?.properties[0].is_checked || false,
    uat: component?.properties[1].is_checked || false,
    prod: component?.properties[2].is_checked || false,
  };
};

export const isNextDisabled = (infraJson) => {
  let final_flag = false;
  infraJson.map((curr_category) => {
    curr_category.components.map((curr_component) => {
      const { component_type, value, is_required, properties } = curr_component;
      if (is_required) {
        switch (component_type) {
          case "multi-select":
            let flag = true;
            properties.map((curr_property) => {
              if (curr_property?.is_checked) {
                flag = false;
              }
            });
            if (flag) {
              final_flag = true;
            }
            break;

          default:
            if (
              value === null ||
              value === "" ||
              value === undefined ||
              value?.length === 0 ||
              value === "No" ||
              value === false
            ) {
              final_flag = true;
            }
            break;
        }
      } else if (component_type === "list") {
        let isDisabled = false;
        (value || [])?.map((curr_value) => {
          if (curr_value?.cost === null || curr_value?.cost === "") {
            isDisabled = true;
          }
        });
        if (isDisabled) {
          final_flag = true;
        }
      }
    });
  });

  return final_flag;
};

export const isSaveAsDraftActive = (infraJson) => {
  let flag = false;
  infraJson.map((curr_category) => {
    curr_category.components.map((component) => {
      if (curr_category.category_id === 12 && component.component_id === 31) {
        if (
          component.value !== "" &&
          component.value !== "undefined" &&
          component.length !== 0
        ) {
          flag = true;
        }
      }
    });
  });
  return flag;
};

export const getPersonaFilteredList = (
  original_list,
  feature_list,
  page,
  userRole,
  filter_key = ""
) => {
  const new_list = [];

  const filtered_list = feature_list.filter(
    (feature) => feature?.page?.toLowerCase() === page.toLowerCase()
  );

  original_list.map((curr_element, index) => {
    filtered_list.map((feature) => {
      if (
        filter_key !== "" &&
        feature.featureName === curr_element[filter_key]
      ) {
        new_list.push(curr_element);
      } else if (filter_key === "" && feature.featureName === curr_element) {
        new_list.push({ label: curr_element, id: index });
      }
    });
  });

  return new_list;
};

export const isUserHasAccess = (feature_list, page, feature_name) => {
  const filtered_list = feature_list.filter(
    (feature) => feature?.page?.toLowerCase() === page.toLowerCase()
  );

  let flag = false;

  filtered_list.map((feature) => {
    if (feature.featureName === feature_name) {
      flag = true;
    }
  });

  return flag;
};

export const getDefaultDiscoverTab = (
  tabsList,
  feature_list,
  defaultTab_index
) => {
  const page = APP_CONSTANTS.PERSONA_PAGE.DISCOVER;

  const modified_list = getPersonaFilteredList(
    tabsList,
    feature_list,
    page,
    "admin"
  );

  let flag = false;
  modified_list.map((feature) => {
    if (feature.id === defaultTab_index) {
      flag = true;
    }
  });

  if (flag) {
    return defaultTab_index;
  } else {
    return modified_list[0].id;
  }
};

// Data Product: app_product_name
// Category: app_category
// Regions: app_regions * (array)
// Product Lines: app_product_lines * (array)
// Functions: app_functions * (array)

const noDataKeyMap = {
  app_product_name: "No Data Product",
  app_category: "No Category",
  app_regions: "No Regions",
  app_product_lines: "No Product Lines",
  app_functions: "No Functions",
};

const isEmpty = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value?.length === 0
  ) {
    return true;
  }
};
export const getGroupByData = (data, group_by_key) => {
  const filteredData = [];
  data.map((curr_data, index) => {
    let curr_filter_pivotData = isEmpty(curr_data[group_by_key])
      ? noDataKeyMap[group_by_key]
      : curr_data[group_by_key];

    if (typeof curr_filter_pivotData === "string") {
      if (filteredData.hasOwnProperty(curr_filter_pivotData)) {
        filteredData[curr_filter_pivotData] = {
          ...filteredData[curr_filter_pivotData],
          data: [...filteredData[curr_filter_pivotData].data, curr_data],
          count: filteredData[curr_filter_pivotData].count + 1,
        };
      } else {
        filteredData[curr_filter_pivotData] = {
          name: curr_filter_pivotData,
          data: [curr_data],
          count: 1,
        };
      }
    } else {
      curr_filter_pivotData.map((curr_filter, index) => {
        if (filteredData.hasOwnProperty(curr_filter)) {
          filteredData[curr_filter] = {
            ...filteredData[curr_filter],
            data: [...filteredData[curr_filter].data, curr_data],
            count: filteredData[curr_filter].count + 1,
          };
        } else {
          filteredData[curr_filter] = {
            name: curr_filter,
            data: [curr_data],
            count: 1,
          };
        }
      });
    }
  });

  const valuesArray = Object.values(filteredData);

  return valuesArray;
};

export const getRPMOwners = (ownerList) => {
  const filteredPwner = ownerList?.filter(
    (owner) => owner.role.toLowerCase() === "rpm"
  ) || [{ email: "No RPM", name: "No RPM", role: "RPM" }];

  const newList = [];

  filteredPwner.map((curr_owner) => {
    const formattedString = curr_owner.name.replace(
      /(\w+), (\w+) \(.+\)/,
      "$2 $1"
    );
    newList.push(formattedString);
  });

  return newList;
};

export const getSigviewStatus = (status) => {
  switch (status) {
    case APP_CONSTANTS.SIGVIEW_AUTOMATE_STATUS.TO_BE_CREATED:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#E0E0E0",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <AddCircleIcon
            sx={{ fontSize: "18px", color: "#333333", marginRight: "4px" }}
          />
          <div style={{ fontSize: "13px", fontWeight: 600 }}>{status}</div>
        </div>
      );

    case APP_CONSTANTS.SIGVIEW_AUTOMATE_STATUS.IN_PROGRESS:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#FBE8D5",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <InfoRoundedIcon
            sx={{ fontSize: "18px", color: "#ED8A2C", marginRight: "4px" }}
          />
          <div style={{ fontSize: "13px", fontWeight: 600 }}>{status}</div>
        </div>
      );

    case APP_CONSTANTS.SIGVIEW_AUTOMATE_STATUS.FAILED:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#F1000026",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CancelRoundedIcon
            sx={{ fontSize: "18px", color: "#F10000", marginRight: "4px" }}
          />
          <div style={{ fontSize: "13px", fontWeight: 600 }}>{status}</div>
        </div>
      );

    case APP_CONSTANTS.SIGVIEW_AUTOMATE_STATUS.COMPLETED:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#55B82A33",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CheckCircleRoundedIcon
            sx={{ fontSize: "18px", color: "#55B82A", marginRight: "4px" }}
          />
          <div style={{ fontSize: "13px", fontWeight: 600 }}>{status}</div>
        </div>
      );

    default:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 8px",
            background: "#55B82A33",
            borderRadius: "5px",
            height: "33px",
          }}
        >
          <CheckCircleRoundedIcon
            sx={{ color: "#55B82A", marginRight: "7px" }}
          />
          <div style={{ fontSize: "14px", fontWeight: 400 }}>{status}</div>
        </div>
      );
  }
};

export function formatedName(userName, limit = 15) {
  const cleaned = userName.replace(/\s*\(.*?\)\s*/g, "").trim();

  // Split by comma
  const parts = cleaned.split(",");
  let displayName = cleaned;

  // Trim and reorder if both parts exist
  if (parts.length === 2) {
    const lastName = parts[0].trim();
    const firstName = parts[1].trim();
    displayName = `${firstName} ${lastName}`;
  }

  return displayName.length > limit
    ? displayName.slice(0, limit) + "..."
    : displayName;
}

// Utility: format owner names nicely - remove parentheses and format properly
export const formattedName = (userName = "") => {
  try {
    // Remove anything in parentheses like "(Contractor)" and clean up spaces
    const cleaned = userName.replace(/\s*\([^)]*\)\s*/g, "").trim();

    // Split by comma if present (format: "LastName, FirstName")
    const parts = cleaned.split(",");

    if (parts.length === 2) {
      // Reorder from "LastName, FirstName" to "FirstName LastName"
      const lastName = parts[0].trim();
      const firstName = parts[1].trim();
      return `${firstName} ${lastName}`.trim();
    }

    // If no comma, return as-is
    return cleaned;
  } catch (e) {
    return userName || "";
  }
};

export function normalizeList(v2, objectList) {
  return v2
    .map((item) => {
      if (typeof item === "string") {
        // find matching object from objectList
        const found = objectList.find((obj) => obj.property_value === item);
        return found
          ? found
          : { property_id: item, property_value: item, cost: 0, score: 0 }; // fallback if not found
      } else if (typeof item === "object" && item !== null) {
        return item; // already object
      }
      return null; // ignore other types
    })
    .filter(Boolean); // remove nulls
}
